import styled from '@emotion/styled';

export const CategoryScrollerContainer = styled.div`
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1;
`;
